export default {

  App: {
    Title: 'STOA',
    Desc : 'ONE ORDER, ONE PAYMENT, MANY PLEASURES',
    Img  : ''
  },

  Search: {
    Title: 'Search'
  },

  Map: {
    Title    : 'Map',
    Satellite: 'Satellite'
  },

  Units: [
    {
      Id      : 1,
      Name    : 'Item (Itm)',
      BaseUnit: 'Itm',
      RateUnit: 'Itm',
      Rate    : 1,
      Divisor : 1.000000
    },
    {
      Id      : 2,
      Name    : 'Kilo (kg)',
      BaseUnit: 'kg',
      RateUnit: 'g',
      Rate    : 1000,
      Divisor : 0.001000
    },
    {
      Id      : 3,
      Name    : 'Liter (L)',
      BaseUnit: 'L',
      RateUnit: 'ml',
      Rate    : 1000,
      Divisor : 0.001000
    }
  ],

  Message: {
    Loading: {
      Title   : 'Loading',
      Wait    : 'Please wait',
      Progress: '%{progress}%'
    },

    Sort: {
      Title : 'Sort',
      SortBy: 'Sort by'
    },

    Group: {
      Title  : 'Group',
      GroupBy: 'Group by'
    },

    Filter: {
      Title   : 'Filter',
      FilterBy: 'Filter by category'
    },

    SaveSuccess: {
      Title: 'Saved Successfully'
    },

    DeleteSuccess: {
      Title: 'Deleted Successfully'
    }
  },

  Confirm: {
    Delete: {
      Title   : 'Delete {Id}',
      SubTitle: 'Delete Confirmation',
      Body    : 'Are you sure you want to proceed with permanent deletion?',
      Validate: {
        Text  : 'To delete, type <span class="font-weight-regular error--text">@:Common.Confirm.Delete.Validate.Answer</span> in the text box below.',
        Answer: 'sudo delete'
      }
    }
  },

  Date: {
    Title     : 'Date | Dates',
    Today     : 'Today',
    Tomorrow  : 'Tomorrow',
    Day       : 'Day | Days',
    Week      : 'Week | Weeks',
    Month     : 'Month | Months',
    Year      : 'Year | Years',
    Period    : 'Period | Periods',
    PeriodFrom: 'From',
    PeriodTo  : 'To',
    Expire    : 'Expire',
    Hour      : 'Hour | Hours',
    Minute    : 'Minute | Minutes',
    Second    : 'Second | Seconds'
  },

  SelectQrItemDialog: {
    Title   : 'Tables',
    Subtitle: 'Select Table'
  },

  QrSourceType: {
    BTH: {
      Id   : '7',
      Title: 'Booth',
      Type : 'BTH',
      Icon : 'mdi-storefront'
    },
    HRM: {
      Id   : '8',
      Title: 'Room',
      Type : 'HRM',
      Icon : 'mdi-alpha-h-box'
    },
    SNB: {
      Id   : '9',
      Title: 'Sunbed',
      Type : 'SNB',
      Icon : 'mdi-umbrella-beach'
    },
    TBL: {
      Id   : '6',
      Title: 'Table',
      Type : 'TBL',
      Icon : 'mdi-table-chair'
    }
  },

  Button: {
    All     : 'All',
    Here    : 'Here',
    Save    : 'Save',
    Update  : 'Update',
    Confirm : 'Confirm',
    Copy    : 'Copy',
    View    : 'View',
    ViewAll : 'View All',
    New     : 'New',
    Add     : 'Add',
    Create  : 'Create',
    Continue: 'Continue',
    Edit    : 'Edit',
    Comments: 'Comments',
    Export  : 'Export',
    Import  : 'Import',
    Delete  : 'Delete',
    Remove  : 'Remove',
    Reset   : 'Reset',
    Login   : 'Login',
    Logout  : 'Logout',
    Cancel  : 'Cancel',
    Change  : 'Change',
    SeeMore : 'See More',
    Close   : 'Close',
    Send    : 'Send',
    Yes     : 'Yes',
    No      : 'No',
    Ok      : 'Ok',
    Next    : 'Next',
    Prev    : 'Previous',
    Toggle  : {
      Active  : 'Active',
      Inactive: 'Inactive',

      ActiveF   : 'Active',
      InactiveF : 'Inactive',
      ActiveFP  : 'Active',
      InactiveFP: 'Inactive',

      ActiveM   : 'Active',
      InactiveM : 'Inactive',
      ActiveMP  : 'Active',
      InactiveMP: 'Inactive'
    }
  },

  Error: {
    Generic    : 'There was a problem. Please try again.',
    Staging    : 'Caution! This is DEMO environment.',
    Development: 'Caution! This is a DEV environment.'
  },

  Misc: {
    From     : 'From',
    To       : 'To',
    Locale   : 'Language',
    CreatedAt: '@:Common.Button.Create',
    UpdatedAt: '@:Common.Button.Update',
    DeletedAt: '@:Common.Button.Delete'
  },

  Marketplace: {
    MaintenanceMode: {
      Title   : 'System Maintenance',
      Subtitle: 'We are currently carrying out system maintenance, please try again in a few minutes.',
      Icon    : 'mdi-wrench-clock'
    },
    Account: {
      Connected: {
        Title   : 'Successfully Connected',
        Subtitle: 'Your account has been successfully connected'
      }
    }
  },

  PushNotifications: {
    notifyButton: {
      dialog: {
        blocked: {
          message: 'Follow these instructions to allow notifications:',
          title  : 'Unblock Notifications'
        },
        main: {
          button: {
            subscribe  : 'SUBSCRIBE',
            unsubscribe: 'UNSUBSCRIBE'
          },
          title: 'Manage Site Notifications'
        }
      },
      message: {
        action: {
          resubscribed: 'You\'re subscribed to notifications',
          subscribed  : 'Thanks for subscribing!',
          unsubscribed: 'You won\'t receive notifications again'
        },
        prenotify: 'Click to subscribe to notifications'
      },
      tip: {
        state: {
          blocked     : 'You\'ve blocked notifications',
          subscribed  : 'You\'re subscribed to notifications',
          unsubscribed: 'Subscribe to notifications'
        }
      }
    },
    promptOptions: {
      actionMessage       : 'We would like to show you notifications',
      acceptButton        : 'Yes',
      cancelButton        : 'No',
      emailLabel          : 'Email Address',
      smsLabel            : 'Mobile Phone Number',
      updateMessage       : 'Update your push notification subscription preferences.',
      negativeUpdateButton: 'Cancel',
      positiveUpdateButton: 'Save Preferences',
      confirmMessage      : 'Thank You!',
      category            : {
        system   : 'System',
        marketing: 'Marketing'
      }
    },
    welcomeNotification: {
      message: 'Thanks for subscribing!'
    }
  },

  Footer: {
    Company: {
      Title: 'About us',
      Items: [
        {
          Title: 'Who are we',
          To   : {name: 'PageAbout'}
        },
        {
          Title: 'How it Works',
          To   : {name: 'PageHowItWorks'}
        },
        {
          Title: 'FAQs',
          To   : {name: 'PageFaq'}
        },
        {
          Title: 'Contact',
          To   : {name: 'PageContact'}
        }
      ]
    },
    Stores: {
      Title: 'Our stores'
    },
    Terms: {
      Title         : 'Terms',
      CookieSettings: 'Cookie Settings'
    },
    FollowUs: {
      Title: 'Follow us',
      Items: [
        {
          Title: 'LinkedIn',
          Icon : 'mdi-linkedin',
          Link : 'https://www.linkedin.com/company/legendary-food-stoa/posts/?feedView=all'
        },
        {
          Title: 'Instagram',
          Icon : 'mdi-instagram',
          Link : 'https://www.instagram.com/stoa.concept'
        },
        {
          Title: 'Facebook',
          Icon : 'mdi-facebook',
          Link : 'https://www.facebook.com/stoa.concept'
        }
      ]
    }
  }
}
